module.exports = __webpack_public_path__ + "img/2fb67c620e4eb56f2520194775deb069.9b142071.png";